export default __webpack_public_path__ + "static/media/Completed.29598b79.svg";